import { computed, signal } from '@angular/core';

export class RichTextOptions {
  // Toolbar actions & Plugins
  public bold = signal<boolean>(false);
  public italic = signal<boolean>(false);
  public underline = signal<boolean>(false);
  public strikethrough = signal<boolean>(false);
  public forecolor = signal<boolean>(false);
  public backcolor = signal<boolean>(false);
  public numlist = signal<boolean>(false);
  public bullist = signal<boolean>(false);
  public hr = signal<boolean>(false);
  public table = signal<boolean>(false);
  public autolink = signal<boolean>(false);
  public link = signal<boolean>(false);
  public emoticons = signal<boolean>(false);
  public codesample = signal<boolean>(false);
  public fullscreen = signal<boolean>(false);
  public image = signal<boolean>(true);
  public autoresize = signal<boolean>(false);
  // Other parameters
  public height = signal<number>(300);
  public resize = signal<boolean | 'both'>('both');
  public imagesFilesTypes = signal<string>('jpg,png,webp,svg');
  public filePickerTypes = signal<string>('image');

  public settingsKeys: string[] = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'forecolor',
    'backcolor',
    'numlist',
    'bullist',
    'hr',
    'table',
    'link',
    'emoticons',
    'codesample',
    'fullscreen',
    'image',
  ];
  public pluginsKeys: string[] = [
    'autolink',
    'link',
    'numlist',
    'bullist',
    'table',
    'emoticons',
    'codesample',
    'fullscreen',
    'image',
    'autoresize',
  ];

  public enabledSettings = computed(() => {
    const set = new Set<string>();
    this.settingsKeys.forEach((key) => {
      if (this[key]() === true) {
        set.add(key);
      }
    });
    return Array.from(set).join(' ');
  });
  public enabledPlugins = computed(() => {
    const set = new Set<string>();
    this.pluginsKeys.forEach((key) => {
      if (this[key]() === false) {
        return;
      }
      switch (key) {
        case 'numlist':
        case 'bullist':
          set.add('lists');
          break;
        default:
          set.add(key);
          break;
      }
    });
    return Array.from(set);
  });
}
